// extracted by mini-css-extract-plugin
export default {"audio":"AudioData_audio__DvZOd"};